import { render, staticRenderFns } from "./registrations-index.vue?vue&type=template&id=0134543a&scoped=true"
import script from "./registrations-index.vue?vue&type=script&lang=js"
export * from "./registrations-index.vue?vue&type=script&lang=js"
import style0 from "./registrations-index.vue?vue&type=style&index=0&id=0134543a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0134543a",
  null
  
)

export default component.exports